import { render, staticRenderFns } from "./numberLayerDrawer.vue?vue&type=template&id=08e50dcc&"
import script from "./numberLayerDrawer.vue?vue&type=script&lang=ts&"
export * from "./numberLayerDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports